import SliderBanners from "../Components/Slider-Banners";
import OurFactory from "../Components/ourfactory";
import UniqueFeatures from "../Components/unique-features";
import LineProducts from "../Components/Line-products";
import HangersProducts from "../Components/Hangers-Products";
import NewFooter from "../Components/new-footer";
function HomePage() {
    return (
        <>
            <SliderBanners />
            <OurFactory />
            <UniqueFeatures />
            <LineProducts />
            <HangersProducts />
            <NewFooter />
        </>
    )
}
export default HomePage;